import { CONTENT_WIDTH, GUTTER_SIZE } from "@/enums";
import { antdWrapperColType } from "@/propTypes";
import { Alert, Col, Form, Row } from "antd";
import { arrayOf, string } from "prop-types";

const DEFAULT_WRAPPER_COL = {
  xs: CONTENT_WIDTH.max,
  sm: CONTENT_WIDTH.max,
  md: CONTENT_WIDTH.threeQuarters,
  lg: CONTENT_WIDTH.half,
  xl: CONTENT_WIDTH.threeEighths,
};

const ValidationMessages = ({ errorMessages, wrapperCol = DEFAULT_WRAPPER_COL }) => (
  <Form.Item wrapperCol={wrapperCol}>
    <Row gutter={GUTTER_SIZE.small}>
      <Col span={CONTENT_WIDTH.max}>
        {errorMessages.map((validationError) => (
          <Alert
            key={validationError}
            message={validationError}
            type="error"
            showIcon
          />
        ))}
      </Col>
    </Row>
  </Form.Item>
);

ValidationMessages.propTypes = {
  errorMessages: arrayOf(string),
  wrapperCol: antdWrapperColType,
};

export default ValidationMessages;
